import { render, staticRenderFns } from "./PermitSelect.vue?vue&type=template&id=2636f3e2&scoped=true"
import script from "./PermitSelect.vue?vue&type=script&lang=js"
export * from "./PermitSelect.vue?vue&type=script&lang=js"
import style0 from "./PermitSelect.vue?vue&type=style&index=0&id=2636f3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636f3e2",
  null
  
)

export default component.exports